/**
 * @generated SignedSource<<35f2eaf10e86592c91a2ede63417abe8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_VehicleRentalStationMap_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VehicleRentalStation",
        "kind": "LinkedField",
        "name": "vehicleRentalStation",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VehicleRentalStationMapContainer_vehicleRentalStation"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_VehicleRentalStationMap_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VehicleRentalStation",
        "kind": "LinkedField",
        "name": "vehicleRentalStation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "004bf9c43c03a6f400af21bca3ff79d2",
    "id": null,
    "metadata": {},
    "name": "routes_VehicleRentalStationMap_Query",
    "operationKind": "query",
    "text": "query routes_VehicleRentalStationMap_Query(\n  $id: String!\n) {\n  vehicleRentalStation(id: $id) {\n    ...VehicleRentalStationMapContainer_vehicleRentalStation\n    id\n  }\n}\n\nfragment VehicleRentalStationMapContainer_vehicleRentalStation on VehicleRentalStation {\n  lat\n  lon\n  name\n}\n"
  }
};
})();

node.hash = "312db870ec8bd4f107693c16cc8cde81";

export default node;
